const STORAGE_KEY = "hobbli_guest_commerce_token";

const randomToken = () => {
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const bytes = new Uint8Array(32);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
};

export const getGuestCommerceToken = () => {
  if (typeof window === "undefined") return null;
  let token = window.localStorage.getItem(STORAGE_KEY);
  if (!token) {
    token = randomToken();
    window.localStorage.setItem(STORAGE_KEY, token);
  }
  return token;
};

export const peekGuestCommerceToken = () => {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(STORAGE_KEY);
};
